import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-a39ba6de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "h-nav"
};
const _hoisted_2 = {
  class: "h-logo"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  class: "n-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "n-left"
}, null, -1));
const _hoisted_6 = {
  class: "n-right"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contract"
}, "400-6868-860", -1));
import { ref, watch, inject, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import countDown from './countdown';
export default {
  __name: 'putin',
  props: {
    name: String
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const source = ref('落地页');
    watch(() => router.currentRoute.value.path, toPath => {
      if (route.meta.name) {
        source.value = '顶部导航栏_免费试用';
      }
    }, {
      immediate: true,
      deep: true
    });
    const showPutinVisible = inject('showPutinVisible');
    const basePath = window.appConfig.VUE_APP_PATH;
    const trackOption = computed(() => {
      return {
        eventName: 'WebUserClick',
        button_name: '立即体验',
        click_info: '顶部导航栏_免费试用',
        event_source: `${source.value}`,
        event_source_pam: null,
        event_target: '留资表单',
        event_target_pam: null
      };
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["header", !props.name ? 'headerMax' : '']),
        ref: "head"
      }, [_withDirectives(_createVNode(_unref(countDown), null, null, 512), [[_vShow, !props.name]]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        to: _unref(basePath)
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["to"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        class: "n-test",
        onClick: _cache[0] || (_cache[0] = $event => _unref(showPutinVisible)(source.value))
      }, [_createTextVNode("免费试用")])), [[_directive_track, _unref(trackOption)]])])])])], 2);
    };
  }
};